import { nanoid } from 'nanoid';
import { ListContainer, ListItem } from 'shared/components/List';
import { messages } from './messages';
import { Card } from 'shared/components';
import { PBody } from 'shared/components/Fonts';

export const PasswordTips = () => (
  <>
    <Card variant="info" className="mb-3">
      <Card.Body $spacing>
        <div>
          <PBody className="fw-semibold">
            Para su seguridad el sistema establece las siguientes normas:
          </PBody>
          <ListContainer>
            {messages.rules.map((rule) => (
              <ListItem key={nanoid()}>{rule}</ListItem>
            ))}
          </ListContainer>
        </div>
      </Card.Body>
    </Card>
    <Card variant="warning">
      <Card.Body $spacing>
        <div>
          <PBody className="fw-semibold">Para su seguridad le aconsejamos:</PBody>
          <ListContainer>
            {messages.tips.map((tip) => (
              <ListItem key={nanoid()}>{tip}</ListItem>
            ))}
          </ListContainer>
        </div>
      </Card.Body>
    </Card>
  </>
);
